
function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <article className="max-w-[720px] mx-auto" style={{ lineHeight: 1.6 }}>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Impressum</h1>

        <p className="mb-4">
          <strong>Anbieter:</strong><br />
          Sportverein Heinersreuth 1921 e.V.<br />
          Bayreuther Str. 47, 95500 Heinersreuth, Deutschland<br />
          Telefon: 0921 / 45533<br />
          E-Mail: <a href="mailto:info@svheinersreuth-padel.de" className="text-gray-600 hover:underline">info@svheinersreuth-padel.de</a><br />
          Homepage: <a href="https://www.svheinersreuth-padel.de" className="text-gray-600 hover:underline" target="_blank" rel="nofollow noopener noreferrer">https://www.svheinersreuth-padel.de</a><br />
          Rechnungsstellung: <a href="mailto:rechnung@sv-heinersreuth.de" className="text-gray-600 hover:underline">info@svheinersreuth-padel.de</a>
        </p>

        <p className="mb-4">
          <strong>Vereinssitz:</strong> 95500 Heinersreuth<br />
          <strong>Registergericht:</strong> Amtsgericht Bayreuth<br />
          <strong>Vereinsregisternummer:</strong> VR 238<br />
          <strong>USt-IdNr.:</strong> nicht vorhanden
        </p>

        <p className="leading-relaxed mb-4">
          <strong>Vertretungsberechtigter Vorstand:</strong><br />
          1. Vorsitzender: Peter Platz, Tel. (0151) 50553221
        </p>

        <p className="leading-relaxed mb-6">
          <strong>Verantwortlich i.S.d. § 18 Abs. 2 MStV (Inhalte):</strong><br />
          Peter Platz, Bayreuther Str. 47, 95500 Heinersreuth
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Haftung für Inhalte und Links</h2>
        <p className="mb-4">
          Die Inhalte dieser Seiten werden mit größter Sorgfalt erstellt; eine Gewähr für Richtigkeit, Vollständigkeit und Aktualität wird nicht übernommen. Für Inhalte externer verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Urheberrecht</h2>
        <p className="mb-4">
          Die auf dieser Website veröffentlichten Inhalte unterliegen dem Urheberrecht. Jede Verwertung bedarf der vorherigen Zustimmung der Rechteinhaber.
        </p>
      </article>
    </div>
  );
}

export default ImpressumPage;
